const getSinceWin = (sinsWin, entries) => {
    /**
     * Flat:  X, F
     * Jumps: J, B
     */
    const flatCodes = ['X', 'F'];
    const jumpsCodes = ['B', 'J'];

    if (!entries) {
        return sinsWin;
    }

    const isFlatEntries = entries.some(entry => flatCodes.includes(entry.courseTypeCode));
    const isJumpsEntries = entries.some(entry => jumpsCodes.includes(entry.courseTypeCode));

    return {
        flat: isFlatEntries ? sinsWin.flat : null,
        jumps: isJumpsEntries ? sinsWin.jumps : null,
    };
};

export default getSinceWin;



// WEBPACK FOOTER //
// ./src/js/human/form/helpers/getSinceWin.js